import { firebase } from '../firebase/firebaseConfig'

export const getCachedToken = () => JSON.parse(localStorage.getItem('token'))?.token

export const resolveAuthToken = async ({ forceRefresh = false } = {}) => {
	if (!forceRefresh) {
		const cachedToken = getCachedToken()
		if (cachedToken) {
			return cachedToken
		}
	}
	const token = await firebase.auth().currentUser?.getIdToken(forceRefresh)
	localStorage.setItem('token', JSON.stringify({ token }))
	return token
}

export const getBearerAuthHeaders = async (extra = {}) => {
	const token = await resolveAuthToken()
	return {
		'Content-Type': 'application/json',
		...extra,
		Authorization: token ? `Bearer ${token}` : '',
	}
}

export const refreshAuthToken = () => resolveAuthToken({ forceRefresh: true })
